/* eslint-disable react/no-unused-state */
import React from 'react';
import Toaster from './Toaster/Toaster';

class Page extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      toasterText: '',
      toasterOnConfirm: null,
      toasterConfirmText: '',
      toasterOnDismiss: null,
      toasterDismissText: '',
      toasterState: 'HIDDEN',
    };
  }

  showLoading(text) {
    this.setState({
      toasterText: text,
      toasterState: 'LOADING',
    });
  }

  showSuccess(text, onDismiss) {
    this.setState({
      toasterText: text,
      toasterOnDismiss: onDismiss,
      toasterState: 'SUCCESS',
    });
  }

  showConfirmation(text, onConfirm, confirmText, onDismiss, dismissText, icon) {
    this.setState({
      toasterText: text,
      toasterOnConfirm: onConfirm,
      toasterConfirmText: confirmText,
      toasterOnDismiss: onDismiss,
      toasterDismissText: dismissText,
      toasterState: 'CONFIRMING',
      confirmationIcon: icon,
    });
  }

  showFailed(text, onDismiss, dismissText) {
    this.setState({
      toasterText: text,
      toasterOnDismiss: onDismiss,
      toasterDismissText: dismissText,
      toasterState: 'FAILED',
    });
  }

  hideToaster() {
    this.setState({
      toasterState: 'HIDDEN',
    });
  }

  renderToaster() {
    const {
      toasterText,
      toasterOnConfirm,
      toasterConfirmText,
      toasterOnDismiss,
      toasterDismissText,
      toasterState,
      confirmationIcon,
      isAdmin,
    } = this.state;
    return (
      <Toaster
        ref="toaster"
        toasterText={toasterText}
        onConfirm={toasterOnConfirm}
        confirmText={toasterConfirmText}
        onDismiss={toasterOnDismiss}
        dismissText={toasterDismissText}
        toasterState={toasterState}
        confirmationIcon={confirmationIcon}
        isAdmin={isAdmin}
      />
    );
  }
}

export default Page;
